<template>
<div class="container Document_container mt-4">
            <b>Document Details : </b>
            <div class="p-fluid formgrid grid" style="margin-top: 1%">
                <div class="field col-4 md:col-4">
                    <table class="table table-bordered" style="border: 1px solid black !important;">
                        <tbody>
                            
                            
                            <tr>
                                <td colspan="4"><strong>1) Estimation File :</strong> <span v-if="Applicationsurvey['estimation_file']" class="highlight">{{ Applicationsurvey['estimation_file'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['estimation_file']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['estimation_file'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>2) Income Certificate File :</strong> <span v-if="Applicationsurvey['income_certificate_file']" class="highlight">{{ Applicationsurvey['income_certificate_file'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['income_certificate_file']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['income_certificate_file'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>3) Rashan Card :</strong> <span v-if="Applicationsurvey['ration_card_file']" class="highlight">{{ Applicationsurvey['ration_card_file'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['ration_card_file']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['ration_card_file'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>4) ZTCC Certificate :</strong> <span v-if="Applicationsurvey['ZTCC_certificate_file']" class="highlight">{{ Applicationsurvey['ZTCC_certificate_file'][0]['name'] }}</span></td>
                                <td>
                                
                                    <Button v-if="Applicationsurvey['ZTCC_certificate_file']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['ZTCC_certificate_file'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>5) MLC Certificate :</strong> <span v-if="Applicationsurvey['MLC_certificate_file']" class="highlight">{{ Applicationsurvey['MLC_certificate_file'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['MLC_certificate_file']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['MLC_certificate_file'][0]['content'])" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4"><strong>6) Illness Certificate :</strong> <span v-if="Applicationsurvey['illness_certificate_file']" class="highlight">{{ Applicationsurvey['illness_certificate_file'][0]['name'] }}</span></td>
                                <td>
                                    
                                    <Button v-if="Applicationsurvey['illness_certificate_file']" icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="ViewDOC(Applicationsurvey['illness_certificate_file'][0]['content'])" />
                                </td>
                            </tr>
                            
                            
                            
                    
                    
                        </tbody>
                    </table>
                </div>
                <div class="field col-8 md:col-8" style="height: 400px;">
                    <iframe :src="`${file}#zoom=50`" style="width: 100%;height: 100%;border: none;" frameborder="0"></iframe>
                </div>
            </div>
        </div>

</template>
<script>
  export default {
    data() {
      return {
        ApplicationDetails: null, // Initialize ApplicationDetails
        Applicationsurvey: [], // Initialize Applicationsurvey as an array
         file:'',
      };
    },
    async mounted() {
      if (localStorage.getItem("applicationdata")) {
        this.ApplicationDetails = await JSON.parse(localStorage.getItem("applicationdata"));

        console.log("data",this.ApplicationDetails);

        if (localStorage.getItem("surveydata")) {
          const survey = JSON.parse(localStorage.getItem("surveydata"));
          this.Applicationsurvey = JSON.parse(survey); // Directly assign the parsed survey to Applicationsurvey
            console.log("surveyData",this.Applicationsurvey);
        }

        // Clear the data from localStorage after usage
        localStorage.setItem("applicationdata", "");
        localStorage.setItem("surveydata", "");
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error!!!",
          detail: "Data Not Found",
          life: 3000,
        });

        //this.$router.push({ name: "ApplicationList" });
        return false;
      }
    },
    methods:{
        ViewDOC(path)
        {       this.file = path;
                //window.open(path);
        },
    }
  };
</script>
<style scoped>


.p-main-container {
    padding-top: 30px;
    background-color: #fff;
    padding-bottom: 30px;
    
}

.p-buttons-wrap {
    width: fit-content;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 10px;
}

table.b {
    table-layout: fixed;
    width: 500px;
}


.p-buttons-wrap button.btn-info:hover,
.p-buttons-wrap button.btn-info:active,
.p-buttons-wrap button.btn-info:visited,
.p-buttons-wrap button.btn-info:focus {
    background-color: #2e4b90 !important;
    color: #fff !important;
    border: none !important;
    outline: none !important;
}



table.profile-table {
    border: 0px solid #d3d3d3;
    width: 100%;
    text-align: left;
    border-collapse: collapse;
}

table.profile-table td,
table.profile-table th {
    border: 1px solid #d3d3d3;
    padding: 8px 15px;
}

table.table-3x td,
table.table-3x th {
    width: 33%;
}

table.profile-table td span.bold {
    font-weight: bold;
    font-size: 14px;
}

.bold {
    font-weight: bold;
    font-size: 14;
    color: #000;
}

table.profile-table tbody td {
    font-size: 13px;
    color: #000000;
}

table.doc-table {
    width: 10%;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
.table tr {
    height: 10px; /* Adjust the height as needed */
  }
  .table td {
    padding: 5px 10px; /* Increase padding for more spacing */
  }




.highlight {
    color: green;
    font-weight: bold;
}
.Remarks {
    color: green;
    font-weight: bold;
}

</style>